import { Button } from "@/lib/components/Button/Button";
import { useSelfQuery } from "@/lib/queries/user-queries";
import { useParams } from "react-router";
import ReferralOverviewDialog from "@/features/Referral/ReferralOverviewDialog";

const PROFILE_PICTURES = [
  "/referral-profile-1.jpeg",
  "/referral-profile-2.jpeg",
  "/referral-profile-3.jpeg",
  "/referral-profile-4.jpeg",
  "/referral-profile-5.jpeg",
];

export default function AdvertiseVideoFooter() {
  const { data: user } = useSelfQuery();
  const { teamExternalId } = useParams();

  if (!user || !teamExternalId) return null;

  return (
    <div className="flex flex-1 items-end self-stretch pt-20">
      <div className="relative flex flex-1 flex-col items-center gap-4 border-t border-border px-6 py-6 md:flex-row">
        <div className="flex-1 overflow-hidden text-center md:text-left">
          <p className="text-sm font-semibold">
            Invite your friends and get rewarded
          </p>
          <p className="text-sm text-text-secondary">
            Earn up to $100 for every invited friend.
          </p>
        </div>
        <ReferralOverviewDialog source="EXPORT_DIALOG">
          <Button size="sm" variant="tertiarySecondary">
            Earn $100
          </Button>
        </ReferralOverviewDialog>
        <ProfilePictures />
      </div>
    </div>
  );
}

function ProfilePictures() {
  return (
    <div className="absolute -top-3.5 right-0 left-0 flex items-center justify-center gap-4">
      {PROFILE_PICTURES.map((src) => (
        <img
          key={src}
          src={src}
          alt=""
          className="size-7 rounded-full border border-border object-cover"
        />
      ))}
    </div>
  );
}
